import {
    REQUEST_BILLINGS_RECEIVED_MANAGER,
    REQUEST_BILLINGS_RECEIVED_MANAGER_FAILURE,
    REQUEST_BILLINGS_RECEIVED_MANAGER_SUCCESS
} from "../../../constant/transaction/BillingConstant";


const initialState = {
    receivedManagers: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const receivedManagersReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_BILLINGS_RECEIVED_MANAGER:
            return {
                ...state,
                receivedManagers: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_BILLINGS_RECEIVED_MANAGER_SUCCESS:
            return {
                ...state,
                receivedManagers: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_BILLINGS_RECEIVED_MANAGER_FAILURE:
            return {
                ...state,
                receivedManagers: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
